import script from "./IntelReportStack.vue?vue&type=script&setup=true&lang=js"
export * from "./IntelReportStack.vue?vue&type=script&setup=true&lang=js"

import "./IntelReportStack.vue?vue&type=style&index=0&id=1895c44b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1895c44b"]])

export default __exports__